import development from './config.development';
import production from './config.production';

const ENV = import.meta.env.VITE_ENVIRONMENT as 'development' | 'production' | 'test' | undefined;
const exports = {
    development,
    production,
    test: development
}[ENV ?? 'development'];

export default exports;
